<template>
  <div class="checkin-rule" v-if="checkinTips.content" v-html="checkinTips.content">
  </div>
</template>
<script>
export default {
  props: {
    checkinTips: {
      type: Object,
      default: function () {
        return {}
      }
    }
  }
}
</script>

<style lang="less" scoped>
.checkin-rule {
  color: #808080;
  h4 {
    font-size: 24px;
    line-height: 32px;
    font-weight: bold;
  }
  ul.rule-list {
    margin-left: 16px;
    li {
      list-style-type: decimal;
      margin: 18px 0;
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>
